import { useMutation } from '@tanstack/react-query';
import { apiPath, apiUpload } from '@/lib/api/client';
import { CubixApiError } from '@/lib/api/types';
import { UploadResponse, DataType } from './types';

interface UploadCsvVars {
  file:     File;
  dataType: DataType;
}

/**
 * Uploads a CSV file to POST /api/v1/alm/data/upload.
 *
 * On success the backend has:
 *   1. Persisted the batch in bronze.raw_csv
 *   2. Published a DataUploadedEvent → CsvAutoTriggerConsumer fires LCR async
 *
 * The response carries the batchId + status="ACCEPTED".
 * Poll GET /api/v1/alm/liquidity to read the refreshed LCR result.
 */
export function useUploadCsv() {
  return useMutation<UploadResponse, CubixApiError, UploadCsvVars>({
    mutationFn: ({ file, dataType }) =>
      apiUpload<UploadResponse>(
        apiPath('alm', 'data', 'upload'),
        file,
        { dataType },
        'file',
      ),
  });
}
